import type { ReactNode } from 'react';
import type { SubjectRecord } from '@ni/shared';
import { RESEARCH_ASIDE } from '../../lib/copy';
import { StatusWord } from '../ui/status-word';
import './record-body.css';

/**
 * **A person's properties in a side panel**: status (the marker and the word)
 * and identity, then whatever the tab adds after them. The Research and
 * Overview asides both lead with these two; `.record-aside` styles the list.
 * The control that changes the status stays in the record's head.
 */
export function RecordProps({ record, children }: { record: SubjectRecord; children?: ReactNode }) {
  return (
    <dl className="prop-list">
      <dt>{RESEARCH_ASIDE.status}</dt>
      <dd>
        <StatusWord vertical={record.subject.vertical} status={record.subject.status} />
      </dd>
      <dt>{RESEARCH_ASIDE.identity}</dt>
      <dd>{record.identity ? RESEARCH_ASIDE.confirmed : RESEARCH_ASIDE.notConfirmed}</dd>
      {children}
    </dl>
  );
}
